import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";
// import Upload from "./views/Upload.vue";
import Profiler from "./views/Profiler";
import Dates from "./views/Dates";
import Wardrobe from "./views/Wardrobe";
Vue.use(Router);

export default new Router({
  base: process.env.BASE_URL,
  mode: "history",
  routes: [
    {
      path: "/",
      name: "home",
      component: Home
    },
    // {
    //   path: "/upload",
    //   name: "upload",
    //   component: Upload
    // },
    {
      path: "/profiler",
      name: "profiler",
      component: Profiler
    },
    {
      path: "/dates",
      name: "dates",
      component: Dates
    },
    {
      path: "/wardrobe",
      name: "wardrobe",
      component: Wardrobe
    },
    {
      path: "/about",
      name: "about",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/About.vue")
    }
  ]
});
